/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum DescriptionAttributeForItsmPolicy {
    tenant_name = 'tenant_name',
    master_account_name = 'master_account_name',
    service_name = 'service_name',
    account_id = 'account_id',
    service_account_name = 'service_account_name',
    policy_classification = 'policy_classification',
    policy_name = 'policy_name',
    policy_description = 'policy_description',
    resource_type = 'resource_type',
    resource_id = 'resource_id',
    resource_name = 'resource_name',
    subscription_id = 'subscription_id',
    subscription_name = 'subscription_name',
    resource_group = 'resource_group',
    location = 'location'
}
